@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.history.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mobile_wallet.feature.history.generated.resources/"

internal val Res.drawable.arrow_outward: DrawableResource by lazy {
      DrawableResource("drawable:arrow_outward", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_outward.xml", -1, -1),
      ))
    }

internal val Res.drawable.feature_history_ic_send: DrawableResource by lazy {
      DrawableResource("drawable:feature_history_ic_send", setOf(
        ResourceItem(setOf(), "${MD}drawable/feature_history_ic_send.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("arrow_outward", Res.drawable.arrow_outward)
  map.put("feature_history_ic_send", Res.drawable.feature_history_ic_send)
}
